import isNil from "lodash/isNil";
import { useNavigate } from "react-router-dom";
import { PROFILE_HOUSEHOLD_DATA_VIEW_PATH } from "../../../../../../constants/env";
import { useProductRequisites } from "../../../../../hooks/use-product-requisites/useProductRequisites";
import { ConfirmExitContent } from "../../../modals/confirm-exit-content/confirm-exit-content";

export function ConfirmExitCreateHouseholdMemberModal(): JSX.Element {
  const navigate = useNavigate();
  const { productRequisites } = useProductRequisites();

  function handleOnExit() {
    const redirectPath = !isNil(productRequisites)
      ? productRequisites.productSurveyPath
      : PROFILE_HOUSEHOLD_DATA_VIEW_PATH;

    navigate(redirectPath, { replace: true });
  }

  return <ConfirmExitContent onExit={handleOnExit} />;
}
